import escapeHtml from 'escape-html';

export default function linebreaksbr(str, escape=true) {
  if (str && escape) {
    return escapeHtml(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2');
  } else if (str && !escape) {
    return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2');
  } else {
    return '';
  }
}
